import { useState, useEffect, useMemo } from "react";

import './Administrators.css';

import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "../../interface/Data";

import { Svg_Delete, Svg_Disable, Svg_Edit, Svg_Search } from "../../components/Svg";
import { Input_Text } from "../../components/Input";

import { OpenPage } from "../../services/OpenPage";
import { AltStatus } from "../../services/Function";

interface DataAdministrator {
    id : string;
    status : number;
    name : string;
    email : string;
    file : string;
}

export default function Page_Administrators() {

    const [ listData, setListData ] = useState<{ [key: string]: DataAdministrator }>(GetDataPage("administrators") || {});
    const [ search, setSearch ] = useState('');

    const dataPage = useMemo(() => {
        const list = Object.keys(listData);
        if(search === ''){
            return list;
        }

        const text = search.toLowerCase();
        return list.filter((elem)=>{
            const showInf = listData[elem];
            return (showInf.name || '').toLowerCase().includes(text) ||
                (showInf.email || '').toLowerCase().includes(text);
        });
    }, [listData, search]);

    useEffect(() => {
        RegisterDataPage("administrators", setListData);
        return () => { UnRegisterDataPage("administrators", setListData); };
    }, []);
    
    return (
        <div className="page_data_list Page_Administrators">
            <div className="div_search">
                <div className="div_input">
                    <Svg_Search className="icons icon_search" color="#B1B2B2" />
                    <Input_Text title="Search" type="text" value={ search } setValue={ setSearch } placeholder="Search by administrator" required={ false } />
                </div>
            </div>

            <table cellPadding={ 0 } cellSpacing={ 0 }>
                <thead>
                    <tr>
                        <th align="center" style={ { width: "20px" } }>#</th>
                        <th>Company</th>
                        <th>Email</th>
                        <th align="right" style={ { width: "20px" } }>#</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dataPage.length > 0 ?
                            dataPage.map((elem, index) => {
                                const showInf = listData[elem];

                                const textStatus  = showInf.status === 1
                                    ? `Are you sure you want to disable the administrator "${ showInf.name }"?`
                                    : `Are you sure you want to enable the administrator "${ showInf.name }"?`;

                                const classStatusTD = showInf.status === 0 ? 'disabled_td' : '';
                                const classStatus   = showInf.status === 0 ? 'data_disabled' : '';
                                const textDelete = `Are you sure you want to delete the administrator "${ showInf.name }"?`;
                                const titleDisable = showInf.status === 1 ? "Disable administrator" : "Enable administrator";

                                return(
                                    <tr key={ elem } className={ classStatus }>
                                        <td className={ classStatusTD } align="center">{ index + 1 }</td>
                                        <td className={ classStatusTD }>
                                            <div className="div_img_td">
                                                {
                                                    showInf.file ?
                                                        <div className="img_td" style={ { backgroundImage: `url("${ showInf.file }")` } } />
                                                    :
                                                    null
                                                }
                                                <div>{ showInf.name }</div>
                                            </div>
                                        </td>
                                        <td className={ classStatusTD }>{ showInf.email }</td>
                                        <td className={ classStatusTD } align="center">
                                            <div className="list_opt">
                                                <div data-tooltip-id="show_alert" data-tooltip-content={ titleDisable } data-tooltip-place="top" onClick={ ()=>{ AltStatus('administrators', titleDisable, 'disable', showInf.id, textStatus, showInf.status === 1 ? "0" : "1") } }>
                                                    <Svg_Disable className="icons" color="#B1B2B2" />
                                                </div>

                                                <div data-tooltip-id="show_alert" data-tooltip-content="Delete administrator" data-tooltip-place="top" onClick={ ()=>{ AltStatus('administrators', 'Delete administrator', 'delete', showInf.id, textDelete, "0") } }>
                                                    <Svg_Delete className="icons" color="#B1B2B2" />
                                                </div>

                                                <div data-tooltip-id="show_alert" data-tooltip-content="Edit administrator" data-tooltip-place="top" onClick={ ()=>{ OpenPage('administrators_details', showInf.id); } }>
                                                    <Svg_Edit className="icons" color="#B1B2B2" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        :
                        <tr>
                            <td colSpan={ 4 } align="center">No data found</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}